function NotFound (props) {
  return (
    <div className="flex justify-center mt-40">
      <p className="text-4xl">Page not found</p>
    </div>
  )
}

export default NotFound